module.exports = __webpack_public_path__ + "static/media/stats.183ee848.png";